import { logoutAtom } from '@breezeventures/web-ph-client-auth/model';
import { useSetAtom } from 'jotai';

export const useAuthService = () => {
  const logout = useSetAtom(logoutAtom);

  return {
    logout,
  };
};
